import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';

function SidebarContainer(props: BoxProps) {
  return <Box {...props} sx={StyleSheet.root} />;
}

SidebarContainer.displayName = 'SidebarContainer';

const StyleSheet = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
};

export default SidebarContainer;
